<template>
    <common-page>
        <drawer-handler is-left to-invisible class="col-lg-3">
            <man-load-details v-if="cubeSelected"></man-load-details>
            <dept-user-tree ref="deptUserTree" v-show="!cubeSelected"></dept-user-tree>
        </drawer-handler>
        <div class="d-flex flex-column col h-100 w-75">
            <div class="card d-flex flex-row align-items-center mb-1 p-1">
                <b-form-datepicker class="w-200px" v-model="fromDate"></b-form-datepicker>
                <i class="el-icon-minus"></i>
                <b-form-datepicker class="w-200px" v-model="toDate"></b-form-datepicker>
                <AvatarButton icon="el-icon-search"
                              class="ml-1"
                              :loading="loading"
                              @btnClick="postRequest"
                              title="查询结果"></AvatarButton>
                <AvatarButton icon="el-icon-download"
                              class="ml-1"
                              @btnClick="postRequest(true)"
                              title="导出"></AvatarButton>
            </div>
            <div class="card overflow-auto">
                <div class="d-flex flex-column" v-if="lazyLoad">
                    <div class="d-flex flex-row mt-1" style="margin-left: 50px; width: max-content">
                        <div v-for="(item,i) of dateStrList" :key="i" class="w-cell ml-1"
                             :class="dateStr === item ? 'badge badge-warning' : ''">
                            {{ item.substring(5, 10) }}
                        </div>
                    </div>
                    <div class="d-flex flex-row mt-1" style="width: max-content"
                         v-for="row of remoteData.manLoadsList" :key="row.userId">
                        <div class="w-50px position-sticky left"
                             :class="userName === row.userName ? 'badge badge-warning' : 'bg-white'">{{ row.userName }}
                        </div>
                        <man-loads-cube class="ml-1" :cube-data="row.manLoadsItemMap[item]"
                                        v-for="item of dateStrList" :key="`${row.userId}*${item}`"
                                        @cubeClick="cubeClick(row,item)"></man-loads-cube>
                    </div>
                </div>
            </div>
        </div>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage";
import moment from "moment";
import ManLoadsCube from "@/components/echarts-part/man-loads/ManLoadsCube";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import AvatarButton from "@/components/echarts-part/CalendarShift/cells/stuffs/AvatarButton";
import DeptUserTree from "@/components/em/EmBusiness/deptUserTree";
import ManLoadDetails from "@/components/echarts-part/man-loads/ManLoadDetails";
import {mapState} from "vuex";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ManLoadsPage",
    components: {ManLoadDetails, DeptUserTree, AvatarButton, DrawerHandler, ManLoadsCube, CommonPage},
    mixins: [emCommonUtilMixin],
    computed: {
        ...mapState({
            dateStr: state => state.manLoad.dateStr,
            userName: state => state.manLoad.userName,
        }),
        cubeSelected() {
            return this.$store.state.manLoad.userName !== '';
        }
    },
    data() {
        return {
            fromDate: new Date(),
            toDate: '',
            loading: false,
            remoteData: {},
            lazyLoad: false,
            dateStrList: []
        }
    },
    mounted() {
        this.toDate = this.getDaysLater(14);
        // this.postRequest();
    },
    methods: {
        postRequest(needExport) {
            let userIds = this.$refs.deptUserTree.getUserIds();
            let tempUserIdList = [];
            for (let item of userIds.split(",")) {
                let number = Number.parseInt(item);
                if (number > 0) {
                    tempUserIdList.push(number);
                }
            }
            if (tempUserIdList.length === 0) {
                this.$message.warning("请选择人员");
                return;
            }
            this.loading = true;
            let payload = {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdOperationUser/manLoads",
                data: {
                    fromDate: moment(this.fromDate).format(
                        this.$t("em.datetime.format.viewMode")
                    ),
                    toDate: moment(this.toDate).format(
                        this.$t("em.datetime.format.viewMode")
                    ),
                    targetIds: tempUserIdList
                }
            };
            if (needExport) {
                payload.data.code = 'export';
                payload.name = '人员负荷';
                this.postExport(payload);
                this.loading = false;
            } else {
                this.doGetRemoteData(payload);
            }
        },
        whenDateChange() {
            this.dateStrList = this.splitDate(this.fromDate, new Date(this.toDate));
        },
        splitDate(fromDate, toDate) {
            let dates = [];
            let tempDate = new Date(fromDate);
            while (tempDate <= toDate) {
                dates.push(this.formatDate(tempDate));
                tempDate.setDate(tempDate.getDate() + 1);
            }
            if (dates.length <= 0) {
                this.$message.warning('开始时间需在目标时间之前')
            }
            return dates;
        },
        formatDate(date) {
            return moment(date).format(
                this.$t("em.date.format.viewMode")
            );
        },
        getDaysLater(day_num) {
            let date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * day_num);
            return date;
        },
        cubeClick(row, col) {
            this.$store.commit('manLoad/setUserName', row.userName);
            this.$store.commit('manLoad/setDateStr', col);
        },
        doGetRemoteData(payload) {
            this.$store.dispatch('api/post', payload).then(response => {
                this.lazyLoad = false;
                this.remoteData = response.data;
                for (let row of this.remoteData.manLoadsList) {
                    let itemMap = row.manLoadsItemMap;
                    for (let dateStr in itemMap) {
                        if (itemMap.hasOwnProperty(dateStr)) {
                            let values = itemMap[dateStr].values;
                            if (values !== undefined) {
                                values.sort((a, b) => {
                                    if (a.fromTime > b.fromTime) {
                                        return -1;
                                    }
                                    if (a.fromTime < b.fromTime) {
                                        return 1;
                                    }
                                    return 0;
                                });
                            }
                        }
                    }
                }
                this.$store.commit('manLoad/setOperationMap', this.remoteData.operationMap);
                this.whenDateChange();
                this.$nextTick(() => this.lazyLoad = true);
            }).finally(() => this.loading = false);
        }
    }
};
</script>

<style scoped>
.w-200px {
    width: 200px;
}

.w-50px {
    width: 50px;
}

.w-cell {
    width: 60px;
}
</style>